// Icon imports
import currencyEthereum from './currency-ethereum.svg';
import rocket from './rocket.svg';
import twitterX from './twitter-x.svg';
import brandInstagram from './brand-instagram.svg';
import brandDiscord from './brand-discord.svg';
import menuHamburger from './menu-hamburger.svg';
import alertTriangleFilled from './alert-triangle-filled.svg';
import brandTelegram from './brand-telegram.svg';
import help from './help.svg';
import screenShare from './screen-share.svg';
import wallet from './wallet.svg';
import userPlus from './user-plus.svg';
import userGroup from './user-group.svg';
import copy from './copy.svg';
import arrowsLogout from './arrows-logout.svg';
import volumeOff from './volume-off.svg';
import volumeFull from './volume-full.svg';
import volumeLow from './volume-low.svg';
import coins from './coins.svg';
import edit from './edit.svg';
import close from './close.svg';
import cup from './cup.svg';
import profilePlaceholder from './profile-placeholder.svg';
import history from './history.svg';  
import bell from './bell.svg';
import cashBanknote from './cash-banknote.svg';
import coinOff from './coin-off.svg';
import card from './card.svg';
import button from './button.svg';
import jars from './jars.svg'
import music from './music.svg'
import toastSuccess from './toast-success.svg'
import toastError from './toast-error.svg'
import toastInfo from './toast-info.svg'
import paw from './paw.svg'

export const icons = {
  paw,
  toastSuccess,
  toastError,
  toastInfo,
  music,
  currencyEthereum,
  rocket,
  twitterX,
  brandInstagram,
  brandDiscord,
  menuHamburger,
  alertTriangleFilled,
  brandTelegram,
  help,
  screenShare,
  wallet,
  userPlus,
  userGroup,
  copy,
  arrowsLogout,
  volumeOff,
  volumeLow,
  volumeFull,
  coins,
  edit,
  close,
  cup,
  profilePlaceholder,
  history,
  bell,
  cashBanknote,
  coinOff,
  card,
  button,
  jars,
};
